<template>
    <div class="container pt-5 text-center">
        <div class="lead">
            <div class="text-center py-4">
                <h2>Psiho Test</h2>
                <h3 class="font-weight-bold">Otkrijte da li ste psihopat</h3>
                <p>Označite polja uz osobine za koje
                    smatrate da opisuju Vašu osobnost.</p>
                <hr />
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q1" type="checkbox" class="mr-2" value="">U govoru često koristite
                    prošlo vrijeme.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q2" type="checkbox" class="mr-2" value="">U govoru često upotrebljavate fraze
                    <em>zato što</em> i <em>tako što</em>
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q3" type="checkbox" class="mr-2" value="">Često pričate o vlastitim potrebama.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q4" type="checkbox" class="mr-2" value="">Preuzimate odgovornost za svoja djela.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q5" type="checkbox" class="mr-2" value="">Često ste kontradiktorni.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q6" type="checkbox" class="mr-2" value="">Kada plačete prvo brišete suze ispod
                    jednog pa ispod drugog oka.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q7" type="checkbox" class="mr-2" value="">Dok izgovarate riječ <em>Ne</em>
                    potvrdno klimam glavom ili obrnuto.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q8" type="checkbox" class="mr-2" value="">Neustrašivi ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q9" type="checkbox" class="mr-2" value="">Sigurni ste u sebe.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q10" type="checkbox" class="mr-2" value="">Karizmatični ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q11" type="checkbox" class="mr-2" value="">Nemilosrdni ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q12" type="checkbox" class="mr-2" value="">Inteligentni ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q13" type="checkbox" class="mr-2" value="">Šarmantni ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q14" type="checkbox" class="mr-2" value="">Omiljeni ste u društvu.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q15" type="checkbox" class="mr-2" value="">Patite od anksioznosti (tjeskobe).
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q16" type="checkbox" class="mr-2" value="">Ne osjećate krivnju za svoja djela.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q17" type="checkbox" class="mr-2" value="">Ljudi se često oslanjaju na Vas.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q18" type="checkbox" class="mr-2" value="">Teško ostvarujete dugotrajne intimne
                    veze.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q19" type="checkbox" class="mr-2" value="">Pošteni ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q20" type="checkbox" class="mr-2" value="">Egocentrični ste.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q21" type="checkbox" class="mr-2" value="">Kažnjavanje ne djeluje na Vas.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q22" type="checkbox" class="mr-2" value="">Osjećate empatiju (suosjećanje) prema
                    tuđoj nesteći.
                </label>
            </div>
            <div class="form-check">
                <label>
                    <input v-model="d.q23" type="checkbox" class="mr-2" value="">Teško planirate.
                </label>
            </div>
            <div class="py-3">
                <button @click="confirm()" class="btn btn-outline-success btn-lg font-weight-bold"><icon name="check"></icon> POTVRDI</button>
            </div>
            <div v-if="d.result" class="text-center mt-3 mb-5">
                <hr>
                <div class="display-4">
                    <span :class="d.resultStyle">{{d.resultStr}}</span>
                </div>
                <em>{{d.note}}</em>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    metaInfo: {
        titleTemplate: "%s | Psiho test",
        meta: [
            {
                name: "description",
                content: "Psiho test.",
            },
        ],
    },
    data() {
        return {
            d: {
                q1: false,
                q2: false,
                q3: false,
                q4: false,
                q5: false,
                q6: false,
                q7: false,
                q8: false,
                q9: false,
                q10: false,
                q11: false,
                q12: false,
                q13: false,
                q14: false,
                q15: false,
                q16: false,
                q17: false,
                q18: false,
                q19: false,
                q20: false,
                q21: false,
                q22: false,
                q23: false,
                result: null,
                resultStr: null,
                resultStyle: null,
                note: 'Napomena: Rezultati testa su samo informativni.'
            }
        };
    },
    methods: {
        confirm() {
            let count = 0;
            let sureSignOfPsychopathy = false;
            if (this.d.q6 || this.d.q7 || this.d.q10 || this.d.q11 || this.d.q16 || this.d.q21 || this.d.q22) {
                sureSignOfPsychopathy = true;
            }
            if (this.d.q1) count = count + 1;
            if (this.d.q2) count = count + 1;
            if (this.d.q3) count = count + 1;
            if (!this.d.q4) count = count + 10; //'ne preuzimam odgovornost za svoja djela
            if (this.d.q5) count = count + 10;
            if (this.d.q6) count = count + 10;
            if (this.d.q7) count = count + 10;
            if (this.d.q8) count = count + 1;
            if (this.d.q9 && sureSignOfPsychopathy) count = count + 1;
            if (this.d.q10) count = count + 10;
            if (this.d.q11) count = count + 10;
            if (this.d.q12 && sureSignOfPsychopathy) count = count + 1;
            if (this.d.q13 && sureSignOfPsychopathy) count = count + 1;
            if (this.d.q14 && sureSignOfPsychopathy) count = count + 1;
            if (!this.d.q15 && sureSignOfPsychopathy) count = count + 1; //'nisam anksiozan
            if (this.d.q16) count = count + 10;
            if (!this.d.q17) count = count + 1; //'ljudi se ne oslanjaju na mene
            if (this.d.q18) count = count + 1;
            if (!this.d.q19) count = count + 10; //'nepošten sam
            if (this.d.q20) count = count + 10;
            if (this.d.q21) count = count + 10;
            if (!this.d.q22) count = count + 10; //'nisam empatican
            if (this.d.q23 && sureSignOfPsychopathy) count = count + 1;

            this.d.result = ((count / 122) * 100).toFixed(0);
            this.d.resultStr = `Vjerojatnost da ste psihopat je ${this.d.result} %`;
            this.d.resultStyle = this.d.result < 50 ? 'text-success' : 'text-danger';

        }
    }
};
</script>


// WEBPACK FOOTER //
// src/pages/psiho/psihotest.vue